<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <!-- <b-card>
        <div slot="header">User Profile</div>-->
        <b-form @submit.prevent="save">
          <b-row>
            <b-col md="8">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth">Invoice Number</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model.lazy="order.expedite_request.InvoiceNumber"
                    required
                    autocomplete="off"
                    :disabled="isSaved"
                    type="text"
                    id="InvoiceNumber"
                    @change.native="addDirtyField"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="8">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth">Customer ID</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model.lazy="order.expedite_request.CustomerID"
                    required
                    :disabled="isSaved"
                    autocomplete="off"
                    type="text"
                    id="CustomerID"
                    @change.native="addDirtyField"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="8">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth">Deliver To</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model.lazy="order.expedite_request.ship_name"
                    autocomplete="off"
                    required
                    :disabled="isSaved"
                    type="text"
                    id="ship_name"
                    @change.native="addDirtyField"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="8">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth">Address</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model.lazy="order.expedite_request.ship_address_1"
                    autocomplete="off"
                    required
                    :disabled="isSaved"
                    type="text"
                    id="ship_address_1"
                    @change.native="addDirtyField"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="8">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth">Ste./Bldg</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model.lazy="order.expedite_request.ship_address_2"
                    autocomplete="off"
                    type="text"
                    :disabled="isSaved"
                    id="ship_address_2"
                    @change.native="addDirtyField"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="8">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth">City</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model.lazy="order.expedite_request.ship_city"
                    autocomplete="off"
                    type="text"
                    required
                    :disabled="isSaved"
                    id="ship_city"
                    @change.native="addDirtyField"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="8">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth">State</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model.lazy="order.expedite_request.ship_state"
                    autocomplete="off"
                    type="text"
                    required
                    :disabled="isSaved"
                    id="ship_state"
                    @change.native="addDirtyField"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="8">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth">Postal Code</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model.lazy="order.expedite_request.ship_postal_code"
                    autocomplete="off"
                    type="text"
                    required
                    :disabled="isSaved"
                    id="ship_postal_code"
                    @change.native="addDirtyField"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="8">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth">Country</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model.lazy="order.expedite_request.ship_country"
                    autocomplete="off"
                    type="text"
                    :disabled="isSaved"
                    id="ship_country"
                    @change.native="addDirtyField"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="8">
              <div class="form-group form-actions" style="float:right;">
                <b-button class="mr-2 mt-2" size="md" variant="outline-primary" @click="back">
                  <!-- <i class="fa fa-close"></i> -->
                  Cancel
                </b-button>
                <b-button
                  class="mr-0 mt-2"
                  size="md"
                  variant="primary"
                  type="submit"
                  :disabled="isClean"
                >
                  <i class="fa fa-save"></i>
                  Save
                </b-button>
              </div>
              <div class="form-group form-actions" style="float:right;">
                <b-alert
                  class="btn mr-4 mt-2"
                  :show="dismissCountDown"
                  fade
                  variant="success"
                  :dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged"
                >
                  Thank you {{this.$store.state.n_user.n_current_user.FirstName}}, your request has been processed
                  <!-- <b-progress variant="info" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress> -->
                </b-alert>
                <b-alert
                  class="btn mr-4 mt-2"
                  :show="dismiss2CountDown"
                  fade
                  variant="danger"
                  :dismissed="dismiss2Countdown=0"
                  @dismiss-count-down="countDown2Changed"
                >
                  Your information could not be saved. Check all fields carefully.
                  <!-- <b-progress variant="info" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress> -->
                </b-alert>
              </div>
            </b-col>
          </b-row>
        </b-form>
        <!-- </b-card> -->
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "ExpeditedRequest",
  data() {
    return {
      selected: [], // Must be an array reference!
      dirtyFields: [],
      isSaving: false,
      isSaved: false,
      dismissSecs: 6,
      dismissCountDown: 0,
      dismiss2Secs: 3,
      dismiss2CountDown: 0,
      dismiss3Secs: 3,
      dismiss3CountDown: 0,
      showDismissibleAlert: false
    };
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
      if (dismissCountDown == 0) {
        this.$store.state.order.expedite_request = {};
        this.isSaving = false;
        this.back();
      }
    },
    countDown2Changed(dismiss2CountDown) {
      this.dismiss2CountDown = dismiss2CountDown;
    },
    countDown3Changed(dismiss3CountDown) {
      this.dismiss3CountDown = dismiss3CountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    addReadOnlyFields() {
      this.dirtyFields = [];
      this.dirtyFields.push({
        FieldName: "RequestedBy",
        FieldValue: this.$store.state.n_user.n_current_user.Email1
      });

      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    },
    addDirtyField: function(event) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== event.target.id
      );
      this.dirtyFields.push({
        FieldName: event.target.id,
        FieldValue: event.target.value
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    },
    save() {
      this.$store.dispatch("saveOp/BuildSaveOperation").then(
        this.$store
          .dispatch("saveOp/EmitSave")
          .then(this.postSave())
          .catch(error => {
            console.log(error.message);
            this.dismiss2CountDown = this.dismiss2Secs;
          })
      );
    },
    postSave() {
      this.dirtyFields = [];
      this.dismissCountDown = this.dismissSecs;
      this.$store.state.saveOp.DestroySaveOperation;
      this.isSaved = true;

      //      this.$store.state.order.expedite_request = {
      //        ExpShipReqID: -1
      //      };
      //      this.addReadOnlyFields();
      //      });
    }
  },
  computed: {
    ...mapState(["order", "n_user"]),
    isClean() {
      return this.dirtyFields.length === 0;
    }
  },
  components: {},
  mounted() {
    this.$store.dispatch("order/createRequest").then(this.addReadOnlyFields());
    this.$store.state.saveOp.localUrl = "Order/DirectShip/";
    this.$store.state.saveOp.localVariableName = "_er";
    this.$store.state.saveOp.localVariableObject = this.$store.state.order.expedite_request;
    this.$store.state.saveOp.localFieldToSet = "ExpShipReqID";
    this.$store.state.saveOp.localReturnObject = "SaveResult";
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.input-group-text {
  color: #111;
}
</style>
